import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("span", null, [
    (!_ctx.icon)
      ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 0,
          title: _ctx.title,
          size: "x-small",
          color: _ctx.getColorName(_ctx.getAcceptabilityName(_ctx.score))
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("mdi-circle")
          ])),
          _: 1
        }, 8, ["title", "color"]))
      : _createCommentVNode("", true),
    (_ctx.icon)
      ? (_openBlock(), _createBlock(_component_v_chip, {
          key: 1,
          variant: "outlined",
          size: "small",
          title: _ctx.title,
          style: {"padding":"0"},
          color: _ctx.getColorName(_ctx.getAcceptabilityName(_ctx.score))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_avatar, null, {
              default: _withCtx(() => [
                (_ctx.state.data && _ctx.state.data.alternatives[_ctx.alternative])
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      size: "medium",
                      color: _ctx.getColorName(_ctx.getAcceptabilityName(_ctx.score))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.state.data.alternatives[_ctx.alternative].icon), 1)
                      ]),
                      _: 1
                    }, 8, ["color"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title", "color"]))
      : _createCommentVNode("", true)
  ]))
}